import {useState} from 'react'
import {Reactivate} from 'entities/user'

export const useReactivate = () => {
  const [isLoading, setIsLoading] = useState(false)

  const reactivateHandler = () => {
    if (isLoading) return

    setIsLoading(true)

    Reactivate().then(() => location.reload()).catch(console.error)
  }

  return {isLoading, reactivateHandler}
}